module.exports = __webpack_public_path__ + "static/media/id-icon.3761fe24.svg";